import { actionTypes } from '../actions/stats';
import { stats as defaultState } from './default.json';

const handlers = {
  [actionTypes.STATS_GET_IN_PROGRESS]: state => ({
    ...state,
    error: null,
    inProgress: true,
  }),
  [actionTypes.STATS_GET_LEVELS_SUCCESS]: (state, action) => ({
    ...state,
    error: null,
    inProgress: false,
    results: action.results,
  }),
  [actionTypes.STATS_GET_ERROR]: (state, action) => ({
    ...state,
    error: action.error.message,
    inProgress: false,
  }),
};

export default (state = defaultState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
